var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgQuestionmarkIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 10,
    cy: 10,
    r: 10,
    fill: "#B2B2B2"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.1431 13.3135C10.6267 13.3135 10.851 12.9775 10.851 12.5296V12.2915C10.8651 11.3676 11.2015 10.9826 12.323 10.2131C13.5217 9.40078 14.2855 8.46308 14.2855 7.11206C14.2855 5.01238 12.5755 3.80859 10.4515 3.80859C8.86731 3.80859 7.47246 4.55756 6.87672 5.90828C6.72958 6.23737 6.66647 6.5593 6.66647 6.82508C6.66647 7.22405 6.89765 7.50417 7.32532 7.50417C7.68271 7.50417 7.92106 7.29423 8.02633 6.9511C8.3906 5.62129 9.26687 5.1175 10.4024 5.1175C11.7692 5.1175 12.8347 5.88737 12.8347 7.10519C12.8347 8.10591 12.2109 8.66585 11.3137 9.29596C10.2131 10.059 9.40713 10.8778 9.40713 12.1097V12.5505C9.40713 12.9984 9.65266 13.3135 10.1431 13.3135ZM10.1428 17.1419C10.6964 17.1419 11.1381 16.694 11.1381 16.1481C11.1388 16.0174 11.1136 15.8878 11.0638 15.7669C11.0141 15.646 10.9408 15.5362 10.8482 15.4437C10.7556 15.3513 10.6456 15.2781 10.5246 15.2284C10.4035 15.1787 10.2737 15.1535 10.1428 15.1542C9.59614 15.1542 9.14036 15.5953 9.14036 16.1481C9.14036 16.694 9.59614 17.1419 10.1428 17.1419Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuestionmarkIcon);
export default __webpack_public_path__ + "static/media/questionmarkIcon.6f8e1d556a836ddf8d1d69ddb79e80c5.svg";
export { ForwardRef as ReactComponent };